import React, { Component } from "react";
import MaterialTable from "material-table";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import {
  ApUseCaseList_Url,
  ApDeleteBusinessType_Url,
  ApUpdateBusinessType_Url,
} from "../../../provider/ServiceUrl";
import PtsButton from "../../givBee/buttons/PtsButton";
import UiUtils from "../../../provider/UiUtils";
import { withRouter } from "../../../withRouter";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CancelIconButton from "../../givBee/buttons/CancelIconButton";
import { ValidatorForm } from "react-material-ui-form-validator";
import SaveButton from "../../givBee/buttons/SaveButton";
class UseCaseList extends Component {
  title = "Business Use Case List";
  breadCrumb = [
    { pageid: "/billingPlans", uiname: "Business Type List" },
    { pageid: "", uiname: "Use Cases" },
  ];
  header = store.getState().adminHeader.adminHeader;

  constructor(props) {
    super(props);

    let action = props.state?.action;
    let propBusinessDomain = null;
    let propBusinessType = null;
    let propBusinessUseCase = null;

    if (props.state) {
      propBusinessDomain = props.state?.businessDomain;
      propBusinessType = props.state?.businessType;
    }
    if (props.state?.businessUseCase) {
      propBusinessUseCase = props.state?.businessUseCase;
    }

    this.state = {
      initialPage: 0,
      pageSize: 20,
      isPaging: false,
      render: false,
      action: action,
      getCreatePermission: false,
      businessTypeName: propBusinessType.name,
      businessUseCaseList: [],
      businessDomain: propBusinessDomain,
      businessType: propBusinessType,
      businessUseCase: propBusinessUseCase,
    };
  }

  componentDidMount() {
    this.getBusinessUseCaseList();
  }

  handleRowClick = (event, rowData) => {
    this.props.navigate(`/planList`, {
      state: {
        action: "view",
        businessUseCase: rowData,
        businessDomain: this.state.businessDomain,
        businessType: this.state.businessType,
      },
    });
  };

  getBusinessUseCaseList() {
    const postObject = {
      businessType: {
        id: this.state.businessType.id,
      },
    };

    AdminFetchServerData.callPostService(ApUseCaseList_Url, postObject).then(
      (output) => {
        if (output && output.data) {
          let businessUseCaseList = output.data.businessUseCaseList || [];
          this.setState({
            businessUseCaseList: businessUseCaseList,
          });
        }
      }
    );
  }
  addBusinessUseCase = () => {
    this.props.navigate("/useCase", {
      state: {
        action: "create",
        businessType: this.state.businessType,
        businessDomain: this.state.businessDomain,
        businessUseCase: this.state.businessUseCase,
      },
    });
  };

  updateBusinessTypeToBackend() {
    const postObject = {
      header: this.header,
      businessType: {
        name: this.state.businessTypeName,
        id: this.state.businessType.id,
        businessUsecaseList: [],
        businessDomain: {
          id: this.state.businessDomain.id,
        },
      },
    };
    AdminFetchServerData.callPostService(
      ApUpdateBusinessType_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let businessType = output.data.businessType;
        this.setState({
          action: "view",
          businessType: businessType,
        });
      }
    });
  }

  editCancel() {
    this.setState({ action: "view" });
  }
  editBusinessTypeDetails() {
    this.setState({
      action: "edit",
      businessTypeName: this.state.businessType?.name,
    });
  }
  deleteBusinessTypeDetails() {
    const postObject = {
      header: this.header,
      businessType: {
        id: this.state.businessType.id,
      },
    };

    AdminFetchServerData.callPostService(ApDeleteBusinessType_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/billingPlans", {
            state: {
              action: "view",
              businessType: this.state.businessType,
              businessDomain: this.state.businessDomain,
            },
          });
        }
      })
      .catch((error) => { });
  }
  viewCancel() {
    this.props.navigate(`/billingPlans`, {
      state: {
        action: "view",
        businessDomain: this.state.businessDomain,
        businessType: this.state.businessType,
      },
    });
  }
  handleMaterialTablePageChange = (page, pageSize) => {
    this.setState({ initialPage: page, pageSize: pageSize });
  };
  handleBusinessTypeChange(e) {
    this.setState({ businessTypeName: e.target.value });
  }
  render() {
    if (this.state.action === "edit") {
      return this.editBusinessType();
    } else if (this.state.action === "view") {
      return this.viewBusinessDetails();
    }
  }
  viewBusinessUseCases() {
    return (
      <>
        <MaterialTable
          title=""
          onRowClick={(event, rowData) => {
            this.handleRowClick(event, rowData);
            event.stopPropagation();
          }}
          icons={UiUtils.getMaterialTableIcons()}
          localization={{
            body: {
              emptyDataSourceMessage: (
                <h5 className="dataNotAvailable">No data found.</h5>
              ),
            },
          }}
          columns={[
            {
              title: "Use Case List",
              field: "name",
              width: "80%",
              align: "left",
              cellStyle: {
                width: "80%",
              },
            },
          ]}
          data={this.state.businessUseCaseList}
          options={{
            sorting: true,
            actionsColumnIndex: -1,
            initialPage: this.state.initialPage,
            pageSize: this.state.pageSize,
            pageSizeOptions: [5, 10, 20, 50, 100],
            paging: this.state.isPaging,
            headerStyle: {
              backgroundColor: "#37517e",
              fontWeight: "bold",
              color: "#ffff",
              align: "left",
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                rowData.id === this.state.businessUseCase?.id ? "#FEF5E7" : "",
              height: "3em",
              textTransform: "capitalize",
            }),
          }}
          onChangePage={(page, pageSize) => {
            this.handleMaterialTablePageChange(page, pageSize);
          }}
          actions={[
            {
              icon: () =>
                true && <PtsButton btnName="Add Use Case" type="submit" />,
              isFreeAction: true,
              onClick: (event) => this.addBusinessUseCase(),
            },
          ]}
        />
      </>
    );
  }
  editBusinessType() {
    return (
      <>
        <div className="row">
          <AdminMenuWithBreadScrum
            businessDomain={this.state.businessDomain}
            businessType={this.state.businessType}
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            name={this.title}
            pageId="viewPage"
          />

          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateBusinessTypeToBackend.bind(this)}
          >
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div className="card-body">
                    <div className="col-md-5">
                      <div className="row">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Domain Name:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <span>{this.state.businessDomain?.name}</span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Business Type:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <input
                            required
                            title=""
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            placeholder="Business Name"
                            value={this.state.businessTypeName}
                            onChange={this.handleBusinessTypeChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton id="saveButton" type="submit">
                  {" "}
                  Save{" "}
                </SaveButton>
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }
  viewBusinessDetails() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          businessDomain={this.state.businessDomain}
          businessType={this.state.businessType}
          name={this.title}
          domainObject={this.state.businessType?.name}
          pageId="viewPage"
          backCallback={this.viewCancel.bind(this)}
          editCallback={this.editBusinessTypeDetails.bind(this)}
          deleteCallback={this.deleteBusinessTypeDetails.bind(this)}
          getDeletePermission={true}
          getUpdatePermission={true}
        />
        <div className="row" style={{ padding: "1em", marginTop: "-12px" }}>
          <div className="card" id="organizationFormCard">
            <div className="card-body">
              <div className="row d-flex">
                <div className="col-md-4">
                  <div className="row">
                    <label
                      className="col-sm-4 col-form-label fw-bold"
                      htmlFor="domain-name"
                      id="assetFormLabel"
                    >
                      Domain Name:
                    </label>
                    <div className="col-sm-8  align-self-center">{this.state.businessDomain.name}</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="row d-flex">
                    <label
                      className="col-sm-4 col-form-label fw-bold"
                      htmlFor="business-type"
                      id="assetFormLabel"
                    >
                      Business Type:
                    </label>
                    <div className="col-sm-8 align-self-center">{this.state.businessType?.name}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.viewBusinessUseCases()}
      </>
    );
  }
}

export default withRouter(UseCaseList);
